module.exports = __webpack_public_path__ + "966a9e3cf8ae5b7894c18be07c63628f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/tractor-unread.svg
// module id = 122
// module chunks = 0